import { RobotoLinkHoverUnderline } from "../RobotoLinkHoverUnderline";

interface TriggerNameLinkProps {
  triggerName: string;
}

/**
 * A plain Roboto UI link to a trigger using its org-unique name.
 *
 * Use this component when the trigger's record has been fetched
 * from the backend, guaranteeing the link points to an extant trigger.
 *
 * If it's necessary to first fetch the trigger record from the backend,
 * use {@link TriggerLink}.
 */
export function TriggerNameLink({ triggerName }: TriggerNameLinkProps) {
  return (
    <RobotoLinkHoverUnderline to={`/triggers/${triggerName}`}>
      {triggerName}
    </RobotoLinkHoverUnderline>
  );
}
